import { Box, Spacer, Text } from '@jfs/ui-new'

const TitleTextWithLabel = ({
  title,
  label,
  titleTextColor,
  labelTextColor,
  titleFontFamily,
  titleFontSize,
  labelFontFamily,
  labelFontSize,
}: any) => {
  return (
    <Box>
      <Text fontFamily={titleFontFamily} fontSize={titleFontSize} color={titleTextColor} title={title} />
      <Spacer size={8} />
      <Text fontFamily={labelFontFamily} fontSize={labelFontSize} color={labelTextColor} title={label} />
    </Box>
  )
}

export { TitleTextWithLabel }
